import React from "react";
import MainSkeleton from "./MainSkeleton";

const TestimonialSkeleton = () => {
  return (
    <div className="skeleton-wrapper px-8 py-12 sm:px-12 sm:py-16">
        <div className="mb-8">
        <MainSkeleton classes={"h-[50px] w-[60px]"}/>
        </div>
      <MainSkeleton classes="h-[22px]" />
      <MainSkeleton classes="h-[22px]" />
      <MainSkeleton classes="h-[22px]" />
      <MainSkeleton classes="h-[22px]" />
      <div className="flex items-center justify-between mt-10">
        <div className="">
          <MainSkeleton classes="w-[50px] h-[22px] bg-red-300" />
          <MainSkeleton classes="w-[50px] h-[22px] bg-blue-400" />
        </div>
        <MainSkeleton classes="h-[22px] w-[100px]" />
      </div>
    </div>
  );
};

export default TestimonialSkeleton;
